import request from '@/utils/request'

const category = () => {
  return request({
    url: '/category',
    method: 'GET'
  })
}
const imgList = query => {
  return request({
    url: '/mural',
    method: 'GET',
    params: query
  })
}
export {
  category,
  imgList
}



// WEBPACK FOOTER //
// ./src/api/interface/product_img.js